module.exports = __webpack_public_path__ + "img/check.bf94b398.svg";